import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface CreateShortTokenResponseModel {
	readonly shortToken: string;
}

export const useCreateShortToken = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse<CreateShortTokenResponseModel>, void> = () => {
		return http<CreateShortTokenResponseModel, undefined>({
			method: "POST",
			url: "/short-token",
			body: undefined
		});
	};

	return useHTTPMutation({ mutationFn });
};
